import { GET_SERVICES } from "../actions/types";

const services = (state = [],action) => {
    switch (action.type) {
        case GET_SERVICES:
            return action.payload;
    
        default:
            return state;
    }
}

export default services;